import enFlag from "../assets/images/lang-icons/flag_uk.png";
import trFlag from "../assets/images/lang-icons/flag_turkey.png";
import esFlag from "../assets/images/lang-icons/flag_spain.png";
import nbFlag from "../assets/images/lang-icons/flag_norway.png";
import roFlag from "../assets/images/lang-icons/flag_romania.png";
import skFlag from "../assets/images/lang-icons/flag_slovakia.png";
import cyFlag from "../assets/images/lang-icons/flag_wales.png";
import frFlag from "../assets/images/lang-icons/flag_french.png";
import hrFlag from "../assets/images/lang-icons/flag_croatian.png";
import srFlag from "../assets/images/lang-icons/flag_serbian.png";
import bsFlag from "../assets/images/lang-icons/flag_bosnian.png";
import slFlag from "../assets/images/lang-icons/flag_slovenian.png";
import csFlag from "../assets/images/lang-icons/flag_czech.png";
import nlFlag from "../assets/images/lang-icons/flag_netherlands.png";

export const SUPPORTED_LANGUAGES = {
  "en-US": {
    key: "en",
    label: "English",
    img: enFlag,
  },
  "tr-TR": {
    key: "tr",
    label: "Turkish",
    img: trFlag,
  },
  "ro-RO": {
    key: "ro",
    label: "Romanian",
    img: roFlag,
  },
  "sk-SK": {
    key: "sk",
    label: "Slovak",
    img: skFlag,
  },
  "cy-GB": {
    key: "cy",
    label: "Welsh",
    img: cyFlag,
  },
  "cs-CZ": {
    key: "cs",
    label: "Czech",
    img: csFlag,
  },
  "nl-NL": {
    key: "nl",
    label: "Dutch",
    img: nlFlag,
  },
  "fr-FR": {
    key: "fr",
    label: "French",
    img: frFlag,
  },
  "es-ES": {
    key: "es",
    label: "Spanish",
    img: esFlag,
  },
  // "pt-PT": {
  //   key: "pt",
  //   label: "Portuguese",
  //   img: "https://flagdownload.com/wp-content/uploads/Flag_of_Portugal_Flat_Round-512x512.png",
  // },
  "nb-NO": {
    key: "nb",
    label: "Norwegian",
    img: nbFlag,
  },
  "hr-HR": {
    key: "hr",
    label: "Croatian",
    img: hrFlag,
  },
  "sr-RS": {
    key: "sr",
    label: "Serbian",
    img: srFlag,
  },
  "bs-BA": {
    key: "bs",
    label: "Bosnian",
    img: bsFlag,
  },
  "sl-SI": {
    key: "sl",
    label: "Slovenian",
    img: slFlag,
  },
};
